module.exports = "/_next/static/images/footer1-4e0ba147b6c37fdc13af624860568d64.svg";